import thumbnail_4 from '../sanaidee/thumbnail.png'

import image0 from '../sanaidee/0.jpg'
import image1 from '../sanaidee/1.jpg'
import image2 from '../sanaidee/2.jpg'
import image3 from '../sanaidee/3.png'
import image4 from '../sanaidee/4.png'
import image5 from '../sanaidee/5.png'
import image6 from '../sanaidee/6.jpg'
import image7 from '../sanaidee/7.png'


export const SanaideeApp = {
  id: 6,
  type: 'mobile',
  thumbnails: [thumbnail_4],
  screens: [image0, image1, image2, image3, image4, image5, image6,image7],
  title: 'Sanaidee – On-Demand Courier & Delivery App for Saudi Arabia',
  intro:
    "Sanaidee is a modern courier app built for Saudi Arabia, connecting individuals and businesses with verified drivers who can deliver anything, anywhere across the Kingdom. Whether you're sending a package across Riyadh or delivering goods to Jeddah, Sanaidee offers a fast, affordable, and secure way to get it done — all from your phone.",
  features: [
    {
      title: "Instant Delivery Requests with Distance-Based Pricing",
      description:
        "Enter pickup and drop-off locations to get real-time pricing based on distance (rate per kilometer). Transparent fares, no bargaining — just clear, upfront pricing tailored to your route."
    },
    {
      title: "Verified Drivers and Registered Companies",
      description:
        "Every driver and logistics partner on Sanaidee is verified according to Saudi regulations, with proper ID, vehicle registration, and commercial licenses. Trust and safety are built in."
    },
    {
      title: "Real-Time Tracking with Live Updates",
      description:
        "Track your delivery live on the map from pickup to drop-off. Stay informed with SMS and push notifications about driver status, ETA, and delivery confirmation."
    },
    {
      title: "Multiple Vehicle Options for All Needs",
      description:
        "Choose the right vehicle for your delivery — whether it’s a motorcycle for small items, a sedan, or a van for larger goods. Perfect for personal and business logistics."
    },
    {
      title: "In-App Chat and Customer Support",
      description:
        "Communicate directly with the assigned driver or contact support instantly via the app. Clear communication means fewer delays and more confidence in every delivery."
    },
    {
      title: "Secure Online Payments & Cash on Delivery",
      description:
        "Pay securely using Mada, Apple Pay, credit/debit cards, or opt for cash on delivery. Sanaidee supports flexible payment options preferred by users in Saudi Arabia."
    },
    {
      title: "Driver Earnings Dashboard and Job Management",
      description:
        "Drivers and registered delivery companies get a dedicated dashboard to view earnings, track completed jobs, and manage availability to maximize income."
    }
  ],
  conclusion:
    "Sanaidee is your trusted courier partner in Saudi Arabia, making item delivery simple, fast, and secure. Whether you're a business delivering orders or an individual sending a personal package, Sanaidee connects you to a network of verified drivers — anytime, anywhere. Download the app today and experience delivery, the smart way!"
};
